import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription, Observable, of, EMPTY } from 'rxjs';
import { Logistiques } from '../logistiques';
import { LogistiquesService } from '../logistiques.service';
import { catchError } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-produits',
  templateUrl: './produits.component.html',
  styleUrls: ['./produits.component.css']
})
export class ProduitsComponent implements OnInit, OnDestroy {
  user = JSON.parse(localStorage.getItem('user'));
  subscription = new Subscription();
  services: Logistiques[];
  form: FormGroup;
  loading = true;
  submitted = false;
  errorLoading = '';
  errorMsg = '';

  constructor(
    private fb: FormBuilder,
    private modal: NgbModal,
    private service: LogistiquesService
  ) { }


  ngOnInit(): void {
    this.getServices();
    this.createForm();
  }

  getServices(): void {
    this.subscription.add(
      this.service.list('services')
        .subscribe(arg => {
          this.services = arg;
          this.loading = false;
        },
          erg => {
            this.errorLoading = 'Erreur de chargement de données';
            this.loading = false;
          })
    );
  }

  open(content): void {
    this.modal.open(content);
  }

  createForm(): void {
    this.form = this.fb.group({
      service: ['', Validators.required]
    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.subscription.add(
      this.service.add('services', this.form.value)
        .subscribe(
          arg => {
            this.getServices();
            this.form.reset();
            this.submitted = false;
            this.modal.dismissAll();
          },
          erg => {
            this.errorMsg = erg.error.message;
            this.submitted = false;
          })
    );
  }



  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
